import { guideSteps } from '@/mocks/homeData';

export default function GuideSteps() {
  return (
    <section id="guide" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-7xl">
        <div data-reveal className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-800 md:text-sm">
            <i className="ri-compass-3-line" />
            <a href="#guide" className="cursor-pointer hover:text-accent-900">
              吃瓜指南
            </a>
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            三步走完，五分钟看完全场
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            不用注册也不用下载，按下面的顺序过一遍，基本不会漏掉当天的主要方向。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {guideSteps.map((step, index) => (
            <div
              key={step.id}
              data-reveal
              data-reveal-delay={String(index * 110)}
              className="relative rounded-lg border border-background-200 bg-background-100 p-6 md:p-7"
            >
              <span className="absolute right-5 top-4 font-heading text-4xl font-black text-background-300 md:text-5xl">
                {step.step}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${step.icon} text-2xl`} />
              </span>
              <h3 className="mt-6 font-heading text-lg font-bold text-foreground-950 md:text-xl">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{step.desc}</p>
            </div>
          ))}
        </div>

        <div
          data-reveal
          className="mt-6 flex flex-col items-start gap-4 rounded-lg bg-secondary-50 px-6 py-6 md:flex-row md:items-center md:justify-between md:px-8"
        >
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-shield-check-line text-xl" />
            </span>
            <div>
              <p className="font-label text-sm font-semibold text-foreground-900 md:text-base">
                只做时间线整理，不代替你的判断
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                我们尽量把可核对的画面和公开信息放在一起，至于怎么理解，交给你自己。
              </p>
            </div>
          </div>
          <a
            href="#faq"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600 cursor-pointer"
          >
            看常见疑问
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}